// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {getFirestore} from 'firebase/firestore'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBF2vIuq3tJPPFrbs8brF_mxvYdengwtug",
  authDomain: "blogging-app-7f789.firebaseapp.com",
  projectId: "blogging-app-7f789",
  storageBucket: "blogging-app-7f789.firebasestorage.app",
  messagingSenderId: "466558686366",
  appId: "1:466558686366:web:2c842563c3ba27841e178f"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);